import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import mapPointerLg from './../../../images/wbu-pointer.png';
import mapPointer from './../../../images/wbu-map-pointer.png';
import template from './storelocator.html';

@Component({
  controllerAs: 'locator',
  template
})

export default class StoreLocator {
  static $inject = [
    '$scope',
    '$ngRedux',
    'spinnerService',
    '$uibModal',
    'orderService',
    'NgMap',
    '$stateParams',
    'authService',
    '$window',
    
    '$state',
    'APP'
  ];

  constructor($scope, $ngRedux, $spinner, $uibModal, $order, NgMap,
    $stateParams,
    $auth,
    $window,
    $state,
    APP
  ) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.mapPointerLg = mapPointerLg;
    this.mapPointer = mapPointer;
    this.$uibModal = $uibModal;
    this.$order = $order;
    this.hasSearched = false;
    this.hasError = false;
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;

    $spinner.show('appSpinner');
    $order.getStoreLocations()
      .finally(() => $spinner.hide('appSpinner'));
    NgMap.getMap()
    .then(map => {
      //  console.log('map', map);
      this.map = map;
    });

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      store: state.auth.storeDetail,
      storeLocations: state.order.storeLocations
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  search(distance, address, form) {
    if (form.$invalid) {
      return;
    }
    var myAddressQuery = address;
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      { address: myAddressQuery,
        region: 'no'
      },
      (results, status) => {
        //  console.log('results', results);
        if (status === 'OK') {
          let lat = results[0].geometry.location.lat();
          let lng = results[0].geometry.location.lng();
          //  console.log('latlng', lat);
          //  console.log('latlng', lng);
          let searchData = {
            'lat': +lat,
            'lng': +lng,
            'distance': +distance
          };
          this.$order.searchStores(searchData)
          .then(
            () => (this.hasSearched = true),
            () => (this.hasError = true)
          );
        }
        else {
          this.hasError = true;
        }
      }
    );
  }

  showHours(storeUrlName) {
    this.storeUrlName = storeUrlName;
    var $ctrl = this;
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-header modalheaderbg"><h5>Store Hours</h5></div>' +
      '<div class="modal-body" id="modal-body">' +
      '<h6 ng-if="!store.storeTimings.length" class="error-text">Timings not Available for this Store</h6>' +
      '<h6 ng-if="store.storeTimings.length" ng-repeat="item in store.storeTimings">' +
      '{{item.day}}: {{formattedTime(changeStringtoDateObject(item.openTime))}} to ' +
      '{{item.isHoliday ? formattedTime(changeStringtoDateObject(item.closeTime)) + " (Off)" ' +
      ': formattedTime(changeStringtoDateObject(item.closeTime))}}' +
      '</h6>' +
      '</div>' +
      '<div class="modal-footer text-center">' +
      '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' +
      '</div>',
      controller: ['$scope', '$uibModalInstance', '$state', 'authService',
        function($scope, $uibModalInstance, $state, authService) {
          authService.getStoreDetail($ctrl.storeUrlName)
          .then(success => $scope.store = success.data);

          $scope.formattedTime = dateTime => {
            const date = dateTime ? new Date(dateTime) : new Date();
            const hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
            let time = (hours < 10 ? `0${hours}` : hours) + ':' +
            (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
            const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
            return time + ampm;
          };

          // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
          $scope.changeStringtoDateObject = stringTime => {
            let timeArray = stringTime.split(':');
            let hours = timeArray[0];
            let minutes = timeArray[1];
            let timeObject = new Date();
            timeObject.setMinutes(minutes);
            return timeObject.setHours(hours);
          };

          $scope.ok = () => $uibModalInstance.close();
        }
      ]
    });
  }

  onMarkerClick(e, storeObj) {
    //  console.log('storeObj', storeObj);
    this.storeObj = storeObj;
    this.map.showInfoWindow('storeInfo', storeObj.storeCode);
  }

}



// WEBPACK FOOTER //
// ./src/app/order/storelocator/storelocator.js